import { useTranslation } from "react-i18next";
import type { PackagingOption } from "~/domains/product/types/PackagingOption";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import Parameter from "~/common/components/Parameter";
import { CollapsibleSection, CollapsedTitle } from "../shared/CollapsibleSection";
import { MiscSectionStyled, PerPackStack, SectionTitle } from "../shared/styled";

// ── MiscParameter ──────────────────────────────────────────────────────────

const MiscParameter = ({ values, label }: { values: string[] | null; label: string }) => {
  if (values === null) {
    return null;
  }
  return <Parameter label={label}>{values.length ? values.join(", ") : "-"}</Parameter>;
};

// ── MiscSection ────────────────────────────────────────────────────────────

interface MiscSectionProps {
  pack: PackagingOption;
  expanded?: boolean;
  onToggle: () => void;
  showToggle?: boolean;
}

export const MiscSection = ({ pack, expanded, onToggle, showToggle = true }: MiscSectionProps) => {
  const { t } = useTranslation();
  return (
    <CollapsibleSection
      expanded={expanded}
      onToggle={onToggle}
      showToggle={showToggle}
      canExpand={true}
      title={
        <>
          <PerPackStack direction={"row"} gap={1}>
            <Icon type={IconType.InfoCircleOutline} />
            <SectionTitle>{t("page.plp.tab.moreInfo")}</SectionTitle>
          </PerPackStack>
          {!expanded && <CollapsedTitle>{t("productDetailsPage.availabilityTable.miscParams")}</CollapsedTitle>}
        </>
      }
    >
      <MiscSectionStyled>
        <MiscParameter values={pack.aliases} label={t("product.customerId")} />
        <MiscParameter values={pack.ean} label={t("common.product.ean")} />
        <MiscParameter values={pack.countriesOfOrigin} label={t("common.product.countryOfOrigin")} />
      </MiscSectionStyled>
    </CollapsibleSection>
  );
};
